import { onScrollEvent } from '../02-core/scrollManager';
// import setupScrollListener from '../02-core/scrollListener';

/**
 * Initializes the scroll-to-top button functionality.
 * - Shows/hides the button based on scroll position.
 * - Smooth scrolls to top on click.
 */
export default function setupScrollToTopButton() {
    const scrollBtn = document.getElementById('scrollTop');

    if (!scrollBtn) return; // Exit if button not present

    const threshold = 300; // px from the top

    // Toggle visibility based on scroll position
    // setupScrollListener(({ direction }) => {
    onScrollEvent(({ position }) => {
        if (position > threshold) {
            scrollBtn.classList.remove('d-none');
        } else {
            scrollBtn.classList.add('d-none');
        }
    }, 150);

    // Scroll to top on click
    scrollBtn.addEventListener('click', () => {
        if($(".cl-booking").length > 0){
            $('header .cl-ctn-mainmenu').addClass('cl-run-scroll-top');
            $('#id-searcher').addClass('cl-run-scroll-top');
            $('header .cl-ctn-mainmenu').css('top','0px');
            $('#id-searcher').css('bottom','0px');
            $('#id-searcher').data('active',0);
        }
        window.scrollTo({ top: 0, behavior: 'smooth' }); // 'fast' | 'smooth
    });
}
